var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"width":"100%","height":_vm.dynaHeight,"src":'/processCenter/taskAlreadyMatter.html?saas_system=tbporderp&saas_token='+_vm.token,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }